import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        route: {
            required: true
        }
    }
});
